import React, { useState } from "react";
import { Textbox } from "../../global/components/inputs/textbox/textbox";
import { Helpers } from "../helpers/helpers";
import { IEpiProps, ISearchResult, SearchContext } from "../models/vertex-search-page-models";
import { useVertexSearchContext, useVertexSearchDispatch } from "../reducers/vertex-search-page-provider";
import { SearchResultPrice } from "./search-result-price";

interface IProps {
    searchResult: ISearchResult
}

interface IContextProps {
    epiProps: IEpiProps
    currentSearchContext: string
}

export const SearchResult = (props: IProps) => {
    const { epiProps, currentSearchContext }: IContextProps = useVertexSearchContext();
    let isHealthyChildren = props.searchResult.url.includes("healthychildren.org");

    //Lock icon should display for Publications page results, with the exception of pages configured in the CMS.
    let showLockIcon = Helpers.showLockIcon(props.searchResult.url, epiProps.publicationsSearchResultLockIconsUrlsToExclude);
    let isProduct = props.searchResult.type == "product" || currentSearchContext == SearchContext.ShopAAP;
    return (
        <div className='vertex-search-result-item'>
            {
                !isProduct && props.searchResult.publishImageUrl && props.searchResult.publishImageUrl.length > 0 ?
                    <div className="vertex-search-result-item-img-mobile"><img src={props.searchResult.publishImageUrl} alt={props.searchResult.title} /></div>
                    : null
            }
            <div className="vertex-search-result-item-header">
                <h5>{props.searchResult.title}</h5>

                {
                    isProduct &&
                    <div className="search-result-icon">
                        <svg className="shop-cart">
                            <use xlinkHref="#icon-cart"></use>
                        </svg>
                    </div>
                }

                {
                    isHealthyChildren &&
                    <div className="search-result-domain-logo">
                        <svg className="icon icon-Red-Book" height="24px" width="24px">
                            <use xlinkHref="#icon-HC"></use>
                        </svg>
                    </div>
                }
            </div>
            {
                props.searchResult.publishDate && props.searchResult.publishDate.length > 0 &&
                <p className="vertex-search-result-item-date">{props.searchResult.publishDate}</p>
            }
            <div className="vertex-search-result-item-inner">
                <div className="vertex-search-result-item-inner-content">
                    <div className={`${isProduct ? 'vertex-search-result-item-excerpt' : ''}`}>
                        <p className="vertex-search-result-item-excerpt-text">
                            <span dangerouslySetInnerHTML={{ __html: props.searchResult.snippet }}></span>
                        </p>

                        {
                          isProduct && props.searchResult.publishImageUrl && props.searchResult.publishImageUrl.length > 0 ?
                                <div className='vertex-search-result-item-img vertex-search-result-item-img-product-mobile'><img src={props.searchResult.publishImageUrl} alt={props.searchResult.title} /></div>
                                : null
                        }
                    </div>
                    <SearchResultPrice searchResult={props.searchResult} />

                    {
                        props.searchResult.keywords && props.searchResult.keywords.length > 0 ?
                            <div className="vertex-search-result-item-tags">
                                {props.searchResult.keywords.map(keyword =>
                                    <span className="search-result-labels-item">{keyword}</span>)}
                            </div>
                            : null

                    }

                    {
                        props.searchResult.productCode && props.searchResult.productCode.length > 0 ?
                            <div className="search-result-product-info">
                                <p className="search-result-product-code">
                                    <b>{epiProps.shopSearchResultProductNumberLabel}</b> {props.searchResult.productCode}
                                </p>
                            </div>
                            : null
                    }
                    <div className="vertex-search-link-container">
                        {
                            showLockIcon &&
                            <div className="search-result-icon">
                                <svg>
                                    <use xlinkHref="#lock-locked"></use>
                                </svg>
                            </div>
                        }
                        <a className="vertex-search-link" href={props.searchResult.url}>{props.searchResult.url}</a>
                    </div>
                </div>
                {
                    props.searchResult.publishImageUrl && props.searchResult.publishImageUrl.length > 0 ?
                        <div className={`vertex-search-result-item-img ${isProduct ? 'vertex-search-result-item-img-product' : 'vertex-search-result-item-img-desktop'}`}><img src={props.searchResult.publishImageUrl} alt={props.searchResult.title} /></div>
                        : null
                }
            </div>
        </div>
    )
}